import { render, staticRenderFns } from "./modern-luxurious-1.vue?vue&type=template&id=00610476"
import script from "./modern-luxurious-1.vue?vue&type=script&lang=js"
export * from "./modern-luxurious-1.vue?vue&type=script&lang=js"
import style0 from "./modern-luxurious-1.vue?vue&type=style&index=0&id=00610476&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports